/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCaretUp = createReactComponent("caret-up", "IconCaretUp", [
  ["path", { d: "M18 14l-6 -6l-6 6h12", key: "svg-0" }]
]);

export { IconCaretUp as default };
//# sourceMappingURL=IconCaretUp.js.map
